// extracted by css-extract-rspack-plugin
export default {"arrow":"tooltip-module__arrow___f6pQP","content":"tooltip-module__content___WMql0"};